import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpVerticalNavigationComponent from './adpVerticalNavigation.component';

let adpVerticalNavigationModule = angular.module('adpVerticalNavigation', [
  uiRouter
])

.component('adpVerticalNavigation', adpVerticalNavigationComponent)

.name;

export default adpVerticalNavigationModule;



// WEBPACK FOOTER //
// ./src/app/components/adpVerticalNavigation/adpVerticalNavigation.js